import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {ApiService} from './api.service';

export const DEFAULT_REPORT_DISCLAIMER_TEXT =
    'Presupuesto sujeto a disponibilidad de materiales y revisión de precios vigente en el momento de la confirmación. Los importes podrán ajustarse si cambian las condiciones de suministro.';
export const DEFAULT_CONTACT_BUTTON_TEXT = 'Contacta con nosotros';
export const DEFAULT_CONTACT_BUTTON_URL = 'mailto:info@obracubica.com';

export interface ITextResource {
    id: string;
    reportDisclaimerText: string;
    contactButtonText: string;
    contactButtonUrl: string;
}

export interface UpdateTextResourceRequest {
    reportDisclaimerText: string;
    contactButtonText: string;
    contactButtonUrl: string;
}

@Injectable({
    providedIn: 'root'
})
export class ApiResourcesService extends ApiService {
    private readonly url = `${environment.api.baseUrl}/resources/text`;

    getResources(): Observable<ITextResource | null> {
        return this.get<ITextResource | null>(this.url);
    }

    updateResources(request: UpdateTextResourceRequest): Observable<ITextResource> {
        return this.put<ITextResource>(this.url, request);
    }
}
